const namespace = {
  filters: {
    navigation: {
      scrollLeftAriaLabel: "Scroll left",
      scrollRightAriaLabel: "Scroll right",
      allFiltersAriaLabel: "View all filters",
    },
    radius: {
      title: "Radius:",
      value: "{{value}} {{unit}}",
    },
    popup: {
      title: "Filters",
      description: "Please select one option",
      cta: {
        reset: "Reset All",
        apply: "Apply Filter",
      },
    },
  },
} as const;

export default namespace;
